import { CalendarDays } from "lucide-react";
import { PublicHeader } from "@/components/public-header";
import { PublicFooter } from "@/components/public-footer";
import { FeatureBlocks, FinalBand, PageHero } from "@/components/marketing/sections";
import { StartFreeButton } from "@/components/marketing/cta";
import { Button } from "@/components/ui/button";
import { useSEO } from "@/hooks/use-seo";
import { seoFor } from "@/data/marketing-routes";
import { PROPERTY_MANAGERS_PAGE as PM } from "@/data/core-pages";
import { TRIAL_DAYS } from "@/lib/marketing/pricing-copy";
import { track } from "@/lib/marketing/analytics";

/** For property managers (build F6, Appendix A8). */
export default function PropertyManagersPage() {
  useSEO(seoFor("/property-managers"));

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <PublicHeader />
      <PageHero title={PM.h1} sub={PM.sub} ctaLocation="property_managers" showButtons={false}>
        <p className="mx-auto mt-5 max-w-2xl text-base text-blue-100/90" data-testid="text-pm-price-line">
          {PM.priceLine}
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <StartFreeButton
            ctaId="property-managers-trial"
            location="property_managers"
            label={`Start ${TRIAL_DAYS}-day free trial`}
            signupParams={{ role: "property_manager" }}
            className="w-full px-8 sm:w-auto"
          />
          <Button
            asChild
            size="lg"
            variant="outline"
            className="w-full border-white/25 bg-transparent px-8 text-white hover:bg-white/10 hover:text-white sm:w-auto"
            data-testid="button-book-call"
          >
            <a
              href={PM.bookCallUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track("cta_clicked", { cta_id: "property-managers-book-call", location: "property_managers" })}
            >
              <CalendarDays size={18} className="mr-1" aria-hidden="true" />
              Book a call with Travis
            </a>
          </Button>
        </div>
      </PageHero>

      <main className="flex-grow">
        <section className="bg-gray-50 px-4 py-14 md:py-20">
          <FeatureBlocks blocks={PM.blocks} />
        </section>
      </main>

      <FinalBand location="property_managers" />
      <PublicFooter />
    </div>
  );
}
